<template>
  <div class="mx-2 mx-md-4 mx-3">
    <div class="bg-white border-radius--light py-2">
      <div class="row">
        <div class="col-md-12 mb-3">
          <em class="fas fa-info-circle text-orange mr-1" />
          <span>Información Adicional</span>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Número de Registro:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.regStudentId }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Número de Seguro Social:
          </span>
          <div
            class="font-16 font-weight-normal color-black d-flex align-items-center"
          >
            <div class="ssn-size">{{ ssn(value.studentSsn) }}</div>
            <div
              v-if="canViewSSN"
              class="d-flex align-items-center"
              @click="showSSN = !showSSN"
            >
              <em
                class="cursor-pointer font-16"
                :class="{
                  'far fa-eye': !showSSN,
                  'far fa-eye-slash': showSSN,
                }"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Estatus de Estudiante:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.studentStatusName }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Impedimento:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.impediment || '-' }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Región:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.regionName || '-' }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Distrito:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.districtName || '-' }}
          </p>
        </div>
        <div class="col-md-6 col-sm col-12">
          <span class="font-14 font-weight-normal color-secondary-6">
            Escuela:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.sieSchoolCode }} - {{ value.locationName }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm col-12">
          <span class="font-14 font-weight-normal color-secondary-6">
            Nombre Contacto:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.contactName }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-12">
          <span class="font-14 font-weight-normal color-secondary-6">
            Parentesco Contacto:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.contactRelationName }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-12">
          <span class="font-14 font-weight-normal color-secondary-6">
            Correo Electrónico Contacto:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.contactEmail }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-12">
          <span class="font-14 font-weight-normal color-secondary-6">
            Teléfono Contacto:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.contactTelephone }}
          </p>
        </div>
      </div>
    </div>
    <div class="bg-gray p-1 m-0 ml-n4 mr-n4 pt-3" />
    <div class="border-radius--light py-2 mt-4">
      <div class="row">
        <div class="col-md-12 mb-3">
          <em class="fas fa-info-circle text-orange mr-1" />
          <span>Información de Transportación</span>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Acompañante:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ transportationInfo.companionFlag == '1' ? 'Si' : 'No' || '-' }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Millaje:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ transportationInfo.mileage || '-' }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Partida-Lugar:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ transportationInfo.departure || '-' }}
            <em class="fas fa-arrow-alt-right text-green mr-1" />
            {{ transportationInfo.location || '-' }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Alternativa de Ubicación:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ transportationInfo.alternatePlacement || '-' }}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="showTherapyInformationPanel"
      class="bg-gray p-1 m-0 ml-n4 mr-n4 pt-3"
    />
    <div
      v-if="showTherapyInformationPanel"
      class="border-radius--light py-2 mt-4"
    >
      <div class="row">
        <div class="col-md-12 mb-3">
          <em class="fas fa-info-circle text-orange mr-1" />
          <span>Información de Terapia</span>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Proveedor:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ thrpyInfo.providerName || '-' }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Lugar de Servicio:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ thrpyInfo.serviceLocation || '-' }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Municipio:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ thrpyInfo.studentMunicipality | capitalize }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Modalidad:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ thrpyInfo.modalityName | capitalize }}
          </p>
        </div>
        <div class="col-md-12 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Dirección Lugar de Servicio:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ thrpyInfo.physicalAddress || '-' }}
          </p>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Frecuencia:
          </span>
          <div class="font-16 font-weight-normal color-black">
            <div>{{ thrpyInfo.frequencyName || '-' }}</div>
            <div class="font-italic color-black font-weight-bold">
              {{ thrpyInfo.durationName }}
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm col-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Especialista:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ specialist(thrpyInfo.specialistAssign) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serviceTypeEnum from '@/views/scholarship/attendance/utils/serviceTypeEnum.js';

export default {
  name: 'AdditionalInfo',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    thrpyInfo: {
      type: Object,
      default: () => {},
    },
    isThrpyService: {
      type: Boolean,
      default: () => false,
    },
    transportationInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    showSSN: false,
  }),
  computed: {
    specialist() {
      return (value) => (value ? this.$options.filters.capitalize(value) : '-');
    },
    ssn() {
      return (value) =>
        !this.showSSN
          ? this.$options.filters.ssn(value).toUpperCase()
          : value.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
    },
    canViewSSN() {
      return this.userHasPermissions(
        'menu.scholarship.paymentmanagement.canviewssn'
      );
    },
    showTherapyInformationPanel() {
      return (
        this.isThrpyService &&
        this.value.payrollDate &&
        this.value.peiAnalysisServiceId !== serviceTypeEnum.educativo
      );
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
.ssn-size {
  min-width: 115px;
}
@media only screen and (max-width: 768px) {
  span,
  p {
    font-size: map-get($fontsSize, 'font-12') !important;
  }
}
</style>
